export default {
  SET_DONATIONS(state, donations) {
    state.donationsState = 'ready'
    state.donations = donations
    state.lastUpdate = parseInt((new Date().getTime() / 1000));
  },
  RESET_DONATIONS(state) {
    state.donationsState = null
    state.donations = []
  },
  LOADING_DONATIONS(state) {
    state.donationsState = 'loading'
  },
  EDIT_DONATION(state, payload) {
    const item = state.donations.find(item => item.id === payload.id);
    Object.assign(item, payload);
  },
  REMOVE_DONATION: (state, donationId) => {
    const i = state.donations.map(item => item.id).indexOf(donationId);
    state.donations.splice(i, 1);
  },
  SET_DONATIONS_STATE(state, status) {
    state.donationsState = status;
  },
  SET_DONATION_STATS_STATE(state, status) {
    state.donationStatsState = status;
  },
  SET_DONATION_STATS(state, donationStats) {
    state.donationStats = JSON.parse(JSON.stringify(donationStats));
  },
  SET_DONATION_SUMMARY_STATE(state, status) {
    state.donationSummaryState = status;
  },
  SET_DONATION_SUMMARY(state, donationSummary) {
    state.donationSummary = JSON.parse(JSON.stringify(donationSummary));
  },
  SET_DONATION_TIME_SERIES(state, donationTimeSeries) {
    state.donationTimeSeries = JSON.parse(JSON.stringify(donationTimeSeries));
  },
  SET_DONATION_TIME_SERIES_STATE(state, status) {
    state.donationTimeSeriesState = status;
  }
}
